import { APPLICANT_SUMMARY, COMBINED_APPLICATION } from '../../server/routes/web/pdf/constants/ids';
import { applicantStatusTypes, idStatusTypes, termsStatusTypes } from '../constants/statusConstants';
import { getApplicationManagerNeedsToIdVerify, getNeedsApplicationManager } from './businessVerification';
import { getGlobalLogger } from '@zg-rentals/logger-base';

const logger = getGlobalLogger(__filename);

const FAILED_PERMISSION_CODE = 'failed-landlord-print-application-permission';

export function doesLandlordHavePermissions(data, variables, pdfId) {
  const reasons = [];
  if (!data) {
    logger.warn({
      code: FAILED_PERMISSION_CODE,
      reasons: ['failed-fetch'],
    });
    return false;
  }
  if (data.user.termSet.status !== termsStatusTypes.TAC_CURRENTLY_ACCEPTED) {
    reasons.push('not-current-terms');
  }
  if (data.user.idVerification.status !== idStatusTypes.CURRENTLY_IDENTIFIED) {
    reasons.push('not-current-id-verification');
  }
  if (pdfId !== APPLICANT_SUMMARY) {
    if (!data.property.application.icraaPageConfig.hasBeenAcceptedFor.includes(variables.applicantId)) {
      reasons.push('missing-icraa-for-applicant');
    }
  }
  if (getNeedsApplicationManager(data)) {
    reasons.push('needs-application-manager');
  }
  if (getApplicationManagerNeedsToIdVerify(data)) {
    reasons.push('application-manager-needs-idv');
  }
  if (reasons.length > 0) {
    logger.warn({
      code: FAILED_PERMISSION_CODE,
      reasons,
    });
    return false;
  }
  return true;
}

export function doesLandlordHavePermissionsForAllApplicants(data) {
  if (!data) {
    logger.warn({
      code: FAILED_PERMISSION_CODE,
      reasons: ['failed-fetch'],
    });
    return false;
  }
  return data.property.application.applicants
    .filter((applicant) => applicant.status === applicantStatusTypes.COMPLETED.id)
    .map((applicant) => applicant.userId)
    .every((applicantId) => doesLandlordHavePermissions(data, { applicantId }, COMBINED_APPLICATION));
}
